import script from "./OrderPopupBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderPopupBtn.vue?vue&type=script&setup=true&lang=js"

import "./OrderPopupBtn.vue?vue&type=style&index=0&id=da2bd010&setup=true&lang=css"

const __exports__ = script;

export default __exports__